import { useMediaQuery as useMuiMediaQuery } from '@mui/material'

const useMediaQuery = (maxWidth: number) => {
  const matches = useMuiMediaQuery(`(max-width:${maxWidth ? maxWidth : '1150'}px)`)
  return matches
}

export default useMediaQuery
